export const event = {
  lite: {
    modal: {
      close: 'lite/modal-close',
      open: 'lite/modal-open',
    },
    smart_banner: {
      close: 'lite/smart-banner-close',
    },
  }
}
